export default "__VITE_ASSET__71534e6c__"